<template>
<div class="hold-transition login-page">
    <div class="login-box">
  <div class="login-logo">
    <!--<img src="http://arendal.com.mx/wp-content/uploads/2018/06/logo13.png" alt="Arendal" />-->
    <img src="@/assets/logoArendal.png" alt="Arendal" />
  </div>
  <!-- /.login-logo -->
  <div class="card">
    <div class="card-body" style="text-align: center;">
      <div class="alert alert-success">                  
                   {{mensaje}}
      </div>
        
    
      
      <p class="mt-3 mb-1" style="text-align:center">
        <a href="https://proveedores.arendal.com.mx">proveedores.arendal.com.mx</a>
      </p>    
    </div>
    <!-- /.login-card-body -->
  </div>
</div>
<!-- /.login-box -->
</div>
</template>

<script>
export default {
    data(){
    return{
       mensaje: this.$route.params.ms
    }
  },
}
</script>